<template>
  <v-main :data-target="targetComponent">
    <AppBar
        :fixed="isHideProgressLinear && targetComponent.includes('Content')"
        :app="!(isHideProgressLinear && targetComponent.includes('Content'))"
        :hide-background="isHideProgressLinear && targetComponent.includes('Content')"
        :extension-height="isHideProgressLinear ? null : '2px'"
        :helpContent="targetComponent.includes('Intro') && isHelpContent"
        @helpContentOpen="helpContentOpen"
    >
      <v-progress-linear v-if="!isHideProgressLinear" absolute bottom height="2" background-color="#D6D6D6" :value="progress" />
    </AppBar>
    <component :is="targetComponent"
               :current="current" :total="total" @next="next" @before="before" @finish="finish" @popupFinish="popupFinish"
               :unitUseNo="unitUseNo" :unitDtlUseList="unitDtlUseList" :unitDtlUseNo="unitDtlUseNo" :unitDtlPageSeq="unitDtlPageSeq"
               :dailyUnitYn="dailyUnitYn" :realtalkReqUseYn="realtalkReqUseYn" :realtalkReqYn="realtalkReqYn"
               :title="intro.title" :smallTitle="intro.smallTitle" :time="intro.time" :description="intro.description"
               :movie="intro.movie" :photo="intro.photo" :sound="intro.sound" :finishSay="finishSay" :freeYn="freeYn" :cmpltYn="cmpltYn" :pastYn="pastYn"
               :key="$route.fullPath"
               :popupYn="popupYn" :regDt="regDt" :preview="preview"
               :emotionList="emotionList" :emotionSelectedList="emotionSelectedList" :emotionSelectParam="emotionSelectParam" @emotionSelect="emotionSelect"
               :isMindNote="isMindNote" :isMindWeather="isMindWeather"
    />
    <HelpContentSheet ref="HelpContentSheet" :helpContent="helpContent"/>
  </v-main>
</template>
<script>
import ProgressLinear from '@/components/progress/ProgressLinear';
import store from '../../store'
import {mixinRemote} from "@/mixins";
import HelpContentSheet from '@/components/layout/bottomSheet/HelpContentSheet'
export default {
  name: 'SolutionContainer',
  mixins: [
    mixinRemote
  ],
  data: () => ({
    intro:{
      title:'',
      smallTitle:'',
      time:0,
      description:'',
      movie:null,
      photo:null,
      sound:null,
    },
    finishSay:'',
    current: 0,
    total: 0,
    unitSet: [],
    unitUseNo:0,
    unitNo:0,
    unitId:0,
    unitDtlUseList:[],
    unitDtlUseNo:[],
    unitDtlPageSeq:[],
    cmpltYn:false,
    freeYn:'',
    helpful:[],
    dailyUnitYn:'N',

    // 광장유닛팝업 start
    popupYn:false,
    regDt:'',
    // 광장유닛팝업 end

    //감정리스트 start
    emotionList: [],
    emotionTitleCd : 'SU008',
    emotionDetailCd : 'SU009',
    emotionSelectedList:[],
    emotionSelectParam:[],
    //감정리스트 end
    realtalkReqUseYn:'Y',
    realtalkReqYn:'',

    isMindNote:false,
    isMindWeather:false,
    targetComponent: '',

    //도서관 컨텐츠 유닛수
    contentCnt:0,

    //미리보기, 피드백
    previewUnitUseNo:'',
    preview:false,
    feedbackUnitUseNo:false,
    feedback:false,

    //과거유닛
    pastYn:'',

    //도움말
    helpContent:'',
    isHelpContent:false,
  }),
  components:{
    ProgressLinear,
    HelpContentSheet
  },
  computed:{
    isHideProgressLinear(){
      // this.$route.meta.isHideProgressLinear -> SolutionContainer 가 component로 바뀌면서 쓸머없어짐
      // Intro, 가이드 피드백, 광장 일 경우 숨김
      return this.popupYn || this.targetComponent.includes('Intro')
      // return true;
    },
    progress(){
          return (100 /this.total) *this.current;
          // return (100 /this.total) * 2;
    },
    isHideInner(){
      // return !this.$route.meta.isHideInner;
      return !this.$route.meta.isHideInner;
    },
  },
  created () {
    // console.log(this.$route)
  },
  mounted() {
    /* 완료된 경우 무조건 인트로 다음페이지*/
    if (typeof this.$route.query.cmpltYn === 'string'){
      this.cmpltYn = this.$route.query.cmpltYn === 'true'
    } else {
      this.cmpltYn = this.$route.query.cmpltYn
    }

    if(this.cmpltYn === undefined){
      this.current = 0
    }else if(this.cmpltYn){
      this.current = 1
    }
    this.freeYn = this.$route.query.freeYn
    this.unitUseNo = this.$route.query.unitUseNo
    this.popupYn = this.$route.query.popupYn
    this.regDt = this.$route.query.regDt
    this.beforeOrdDtlNo = this.$route.query.beforeOrdDtlNo

    if(this.freeYn === undefined || this.freeYn === null || (this.freeYn + '').trim() === ''){
      this.freeYn = 'N'
    }

    // 어드민 유닛 미리보기 접근
    this.previewUnitUseNo = this.$route.query.previewUnitUseNo
    if(this.previewUnitUseNo !== undefined && (this.previewUnitUseNo + '').trim() !== ''){

      this.unitUseNo = this.previewUnitUseNo
      this.freeYn = 'Y'
      this.preview = true
    }

    // 가이드 피드백 접근
    this.feedbackUnitUseNo = this.$route.query.feedbackUnitUseNo
    if(this.feedbackUnitUseNo !== undefined && (this.feedbackUnitUseNo + '').trim() !== ''){

      this.unitUseNo = this.feedbackUnitUseNo
      //솔루션 리스트 (투데이 플랜 기준으로 무료여부 체크)
      const isFree = store.state.remote.solutions.some(item => {
        if (item.freeYn === "Y" && item.unitUseNo == this.feedbackUnitUseNo) return true
      })

      // TODO user_key = 1 && feedbackUnitUseNo = 159 / 152 일때, freeYn : Y로
      if (store.getters.userKey === 1 && (this.feedbackUnitUseNo == 159 || this.feedbackUnitUseNo == 152)){
        this.freeYn = 'Y'
      }else {
        this.freeYn = isFree?"Y":"N"
      }

      this.cmpltYn = true
      this.feedback = true
    }

    this.pastYn = this.$route.query.pastYn
    if(this.cmpltYn === undefined){
      this.pastYn = 'N'
    }

    /* 유닛정보 불러오기 */
    this.getUnitUse(this.unitUseNo)

    /* 첫화면 불려오기 */
    // setTimeout(() => this.nextUnit(this.current), 500); // 조회하여 unitSet에 셋팅하는 속도보다 빨라 500으로 변경
   },
   methods:{
    // HelpContentSheet
    helpContentOpen() {
      this.$nextTick(() => {
        this.$refs.HelpContentSheet.sheetOpen(true)
      })
    },
    async getUnitUse (unitUseNo) {
            await store.dispatch('getUnitUse', this.$_payload({'unitUseNo': unitUseNo,'freeYn': this.freeYn}))
                .then(res => {
                if (res.success) {
                  this.unitNo = res.data.unitNo
                  this.unitId = res.data.unitId
                  this.helpful = res.data.helpful.split(',')

                  // 인트로 정보 셋팅
                  this.intro.title = res.data.title
                  this.intro.smallTitle = res.data.smallTitle
                  this.intro.time = res.data.duraTime
                  this.intro.description = res.data.content
                  this.intro.movie = res.data.videoAtchFileName
                  this.intro.photo = res.data.imgAtchFileName
                  this.intro.sound = res.data.musicAtchFileName

                  // 도움말
                  this.helpContent = res.data.helpContent
                  if(this.helpContent.trim() != ''){
                    this.isHelpContent = true // 도움말 존재시만 노출
                  }

                  // 마무리
                  this.finishSay = res.data.finishSay

                  // 매일 여부
                  this.dailyUnitYn = res.data.dailyUnitYn

                  // 찐한대화 요청 사용 여부
                  this.realtalkReqUseYn = res.data.realtalkReqUseYn

                  // 찐한대화 요청 여부
                  this.realtalkReqYn = res.data.realtalkReqYn

                  // 유닛상세 리스트
                  this.unitDtlUseList = res.data.unitDtlList

                  // unitSet 설정
                  this.settleUnitSet()

                  // 유닛 사용 상세 리스트
                  this.settleDetailList()
                  this.total = this.unitSet.length -1;

                } else {
                  console.log(res.msg)
                }
                })
                .catch(error => {
                    console.error(error)
                })
                .finally(() => {
                  this.nextUnit(this.current)
                })
    },
    async setMemberUnitCmplt (val) {
        if(val){
          this.realtalkReqYn = 'Y'
        }else{
          this.realtalkReqYn = 'N'
        }

        await store.dispatch('setMemberUnitCmplt', this.$_payload('suSltUnitMappingInfoUse',{sltUnitMappingUseNo: this.unitUseNo, realtalkReqYn: this.realtalkReqYn, freeYn: this.freeYn}))
              .then(res => {
                if (res.success) {
                    store.dispatch('getTodayPlanList', true)
                    // setTimeout(() => this.$router.push({name: '미션완료', params: {'unitUseNo':this.unitUseNo,'helpful': this.helpful}}), 1000); // 저장한 이후
                    setTimeout(() => this.$router.replace({name: '미션완료', params: {'unitUseNo':this.unitUseNo,'helpful': this.helpful, 'contentCnt': this.contentCnt, 'preview': this.preview, 'freeYn': this.freeYn, 'unitId': this.unitId}}), 1000); // 저장한 이후
                } else {
                    console.log(res.msg)
                    alert("완료처리에 실패하였습니다.")
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
    },
    async getTravelEmotionList () {
        await store.dispatch('getTravelEmotionList', this.$_payload('so',[
              {'emotionTitleCd':this.emotionTitleCd},
              {'emotionDetailCd':this.emotionDetailCd}
            ]))
            .then(res => {
              if (res.success) {
                  this.emotionList = res.data;
              } else {
                  console.log(res.msg)
                  this.emotionList = []
              }
            })
            .catch(error => {
              console.error(error)
              this.emotionList = []
            })
            .finally(() => {})
    },
    async getUnitEmotion(unitUseNo, unitDtlUseNo, unitDtlPageSeq) {
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': unitUseNo}
            , {'unitDtlUseNo':unitDtlUseNo}
            , {'unitDtlPageSeq':unitDtlPageSeq}
            , {'freeYn':this.freeYn}
            , {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]                                          ))
          .then(res => {
          if (res.success && res.data.unitDtlQuesList != null) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {
              // 초기화
              this.emotionSelectedList.splice(0, this.emotionSelectedList.length)

              if(quesEl.memberUnitDtlReplyList.length > 0){
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {
                  this.emotionSelectedList.push({reply:userReplyEl.reply, score:userReplyEl.score})
                });
              }
            });
            setTimeout(() => {
                this.emotionSelectParam.splice(0, this.emotionSelectParam.length)

                this.emotionSelectedList.forEach((selVal) => {
                  // 감정 리스트 에서 데이터 찾기
                  this.emotionList.forEach((val) => {
                    val.detailCodeList.forEach((detail) => {
                      if(detail.cd == selVal.reply){
                        this.emotionSelectParam.push({color:val.descCont, cdNm:detail.cdNm, cd:detail.cd, score:selVal.score})
                      }
                    })
                  })
                })
            }, 200);

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    before(){
      this.current= this.current - 1;
      this.nextUnit(this.current);
    },
    next () {
      this.current= this.current + 1;
      this.nextUnit(this.current);
    },
    finish(val){
      this.unitSet.forEach(o => { //컨텐츠형 수 체크
        if (o.name === 'Content') {
          this.contentCnt+=1
        }
      });

      if(!this.cmpltYn){ // 완료상태가 아닐때만 저장
        this.setMemberUnitCmplt(val)
      } else{

        if(this.feedback){ //피드백인경우 완료버튼시 닫힘
          window.close();
        }

        this.solutionComplete = true
        if (this.$route.query.progYn !== undefined && this.$route.query.progYn === 'N') {
          this.$router.replace({name: '여행지도', params: {beforeOrdDtlNo: this.$route.query.beforeOrdDtlNo}})
        }
        if(this.contentCnt > 0){
          this.$router.go(-this.contentCnt)
        }else{
          this.$router.back()
        }

        // this.$router.push({name: '메인', params: {'solutionComplete': true}})
      }
    },
    popupFinish(){
      window.parent.postMessage('close', '*');
    },
    nextUnit(index){
      if (this.popupYn) index -= 1
      let componentName = this.unitSet[index].name
      let importedComponents = Object.keys(this.$options.components).filter(c => c === componentName)
      if (!importedComponents.length) {
        this.$options.components[componentName] = () => import(`${this.unitSet[index].path}.vue`)
      }
      this.targetComponent = componentName
    },
    emotionSelect(val){
      this.emotionSelectedList = val

      this.emotionSelectParam = val
    },
    settleUnitSet () {
      // 고정형
      if(this.unitDtlUseList[0].unitType == '12'){ // 마음노트 - 완료
        // this.unitSet = ['mindNoteIntro','mindNote1','mindNote2','mindNote3','finish']
        this.unitSet = [
          {name: 'IntroMindNote', path: './SolutionIntroMindNote'},
          {name: 'MindNote1', path: './mindNote/MindNote1'},
          {name: 'MindNote2', path: './mindNote/MindNote2'},
          {name: 'MindNote3', path: './mindNote/MindNote3'},
        ]
        this.isMindNote = true

      } else if(this.unitDtlUseList[0].unitType == '13'){  // 감정일기
        // 감정 리스트 조회
        this.getTravelEmotionList()

        if(this.unitDtlUseList[0].dtlType == '17'){  // 초급
          // this.unitSet = ['intro','emotionDiary1','emotionDiary2','emotionDiary3','emotionDiary4','emotionDiary5','finish']
          this.unitSet = [
            {name: 'Intro', path: './SolutionIntro'},
            {name: 'EmotionDiary1', path: './emotionDiary/EmotionDiary1'},
            {name: 'EmotionDiary2', path: './emotionDiary/EmotionDiary2'},
            {name: 'EmotionDiary3', path: './emotionDiary/EmotionDiary3'},
            {name: 'EmotionDiary4', path: './emotionDiary/EmotionDiary4'},
            {name: 'EmotionDiary5', path: './emotionDiary/EmotionDiary5'},
          ]
          // emotionDiary1 답변 조회해서 감정 리스트 set
          this.getUnitEmotion(this.unitUseNo, this.unitDtlUseList[0].unitDtlUseNo, 1)
        }
        else if(this.unitDtlUseList[0].dtlType == '18'){ // 고급
          // this.unitSet = ['intro','emotionDiaryHigh1','emotionDiaryHigh2','emotionDiaryHigh3','emotionDiaryHigh4','emotionDiaryHigh5','EmotionDiaryHigh6','finish']
          this.unitSet = [
            {name: 'Intro', path: './SolutionIntro'},
            {name: 'EmotionDiaryHigh1', path: './emotionDiaryHigh/EmotionDiaryHigh1'},
            {name: 'EmotionDiaryHigh2', path: './emotionDiaryHigh/EmotionDiaryHigh2'},
            {name: 'EmotionDiaryHigh3', path: './emotionDiaryHigh/EmotionDiaryHigh3'},
            {name: 'EmotionDiaryHigh4', path: './emotionDiaryHigh/EmotionDiaryHigh4'},
            {name: 'EmotionDiaryHigh5', path: './emotionDiaryHigh/EmotionDiaryHigh5'},
            {name: 'EmotionDiaryHigh6', path: './emotionDiaryHigh/EmotionDiaryHigh6'},
          ]

          // emotionDiaryHigh3 답변 조회해서 존재하는 경우 감정 리스트, score set
          this.getUnitEmotion(this.unitUseNo, this.unitDtlUseList[0].unitDtlUseNo, 2)
        }

      } else if(this.unitDtlUseList[0].unitType == '14'){  // 수면일지
        // this.unitSet = ['intro','sleepDiary1','sleepDiary2','sleepDiary3','sleepDiary4','sleepDiary5','sleepDiary6','sleepDiary7','sleepDiary8','sleepDiary9','sleepDiary10','finish']
        this.unitSet = [
          {name: 'Intro', path: './SolutionIntro'},
          {name: 'SleepDiary1', path: './sleepDiary/SleepDiary1'},
          {name: 'SleepDiary2', path: './sleepDiary/SleepDiary2'},
          {name: 'SleepDiary3', path: './sleepDiary/SleepDiary3'},
          {name: 'SleepDiary4', path: './sleepDiary/SleepDiary4'},
          {name: 'SleepDiary5', path: './sleepDiary/SleepDiary5'},
          {name: 'SleepDiary6', path: './sleepDiary/SleepDiary6'},
          {name: 'SleepDiary7', path: './sleepDiary/SleepDiary7'},
          {name: 'SleepDiary8', path: './sleepDiary/SleepDiary8'},
          {name: 'SleepDiary9', path: './sleepDiary/SleepDiary9'},
          {name: 'SleepDiary10', path: './sleepDiary/SleepDiary10'},
        ]

      } else if(this.unitDtlUseList[0].unitType == '15'){  // 마음날씨 - 완료
        // this.unitSet = ['mindWeatherIntro','mindWeather','finish']
        this.unitSet = [
          {name: 'IntroMindWeather', path: './SolutionIntroMindWeather'},
          {name: 'MindWeather', path: './mindWeather/MindWeather'},
        ]
        this.isMindWeather = true

      } else if(this.unitDtlUseList[0].unitType == '16'){  // 꿈일기
        // this.unitSet = ['dreamDiaryIntro','dreamDiary1','dreamDiary2','dreamDiary3','dreamDiary4','finish']
        this.unitSet = [
          {name: 'IntroDreamDiary', path: './SolutionIntroDreamDiary'},
          {name: 'DreamDiary1', path: './dreamDiary/DreamDiary1'},
          {name: 'DreamDiary2', path: './dreamDiary/DreamDiary2'},
          {name: 'DreamDiary3', path: './dreamDiary/DreamDiary3'},
          {name: 'DreamDiary4', path: './dreamDiary/DreamDiary4'},
        ]

      } else {  // 조합형
        // var cnt = 0
        this.unitSet.push({name: 'Intro', path: './SolutionIntro'})

        this.unitDtlUseList.forEach((element) => {
          if(element.unitType == '01'){ // 몸 알아차리기 - 완료
            // this.unitSet[++cnt] = 'body1'
            this.unitSet.push({name: 'Body1', path: './solutionBody/SolutionBody01'})

          } else if(element.unitType == '02') { // 감정리스트
            // this.unitSet[++cnt] = 'emotionList1'
            // this.unitSet[++cnt] = 'emotionList2'
            this.unitSet.push({name: 'EmotionList1', path: './emotionList/EmotionList1'})
          } else if(element.unitType == '03') { // 감정온도계
            var selectCnt = element.unitDtlQuesList[0].selectCnt
            if (selectCnt > 0) {
              this.unitSet.push({name: 'EmotionThermometer2', path: './emotionThermometer/EmotionThermometer2'})
              this.unitSet.push({name: 'EmotionThermometer3', path: './emotionThermometer/EmotionThermometer3'})
            }
            // 온도계 선택개수가 1개일 경우 EmotionThermometer1 페이지에서 제어하도록 의도 하였으나, sr-20412 건 이후 사용안함
            // else{
            //   this.unitSet.push({name: 'EmotionThermometer1', path: './emotionThermometer/EmotionThermometer1'})
            // }

          } else if(element.unitType == '04') { //시계형 -- 시간형, 시각형 따로 작업필요
            if(element.dtlType == '01'){  // 시간형
              this.unitSet.push({name: 'SolutionTime1', path: './solutionTime/SolutionTime1'})
            } else if(element.dtlType == '02'){ // 시각형
              this.unitSet.push({name: 'SolutionTime2', path: './solutionTime/SolutionTime2'})
            }

          } else if(element.unitType == '05') { // 그래프형
            if(element.dtlType == '03'){  // 지정형
              // this.unitSet[++cnt] = 'solutionGraph2'
              this.unitSet.push({name: 'SolutionGraph2', path: './solutionGraph/SolutionGraph2'})
            } else if(element.dtlType == '04'){ // 자율형
              this.unitSet.push({name: 'SolutionGraph1', path: './solutionGraph/SolutionGraph1'})
              this.unitSet.push({name: 'SolutionGraph2', path: './solutionGraph/SolutionGraph2'})
              // this.unitSet[++cnt] = 'solutionGraph1'
              // this.unitSet[++cnt] = 'solutionGraph2'
            }


          } else if(element.unitType == '06') { // 호흡형
            // ['intro','solutionBreath1','solutionBreath2','solutionBreath3','solutionBreath4','finish'] solutionBreath4 - 워크시트 단답형으로

            // 호흡형의 경우 관리자에서 시간설정 안한경우 사용자 페이지 추가
            // var timeSet = element.unitDtlQuesList[0].timeSet
            // if(timeSet == null || timeSet <= 0 || timeSet == ''){
              // this.unitSet[++cnt] = 'solutionBreath1'
            this.unitSet.push({name: 'SolutionBreath1', path: './solutionBreath/SolutionBreath1'})
            // }
            // this.unitSet[++cnt] = 'solutionBreath2'
            this.unitSet.push({name: 'SolutionBreath2', path: './solutionBreath/SolutionBreath2'})
            // this.unitSet[++cnt] = 'solutionBreath3' -- 2와 동일하게 작업되어있음

          } else if(element.unitType == '07') { // 몰입훈련
            this.unitSet.push({name: 'ImmersionTraining1', path: './immersionTraining/ImmersionTraining1'})
            this.unitSet.push({name: 'ImmersionTraining2', path: './immersionTraining/ImmersionTraining2'})
            // this.unitSet[++cnt] = 'immersionTraining1'
            // this.unitSet[++cnt] = 'immersionTraining2'
            // this.unitSet[++cnt] = 'immersionTraining3' -- 2와 합침

          } else if(element.unitType == '08') { // 시간제한활동
            // ['intro','timeLimit1','timeLimit2','timeLimit3','finish']

            // var time = element.unitDtlQuesList[0].timeSet
            // if(time == null || time <= 0 || time == ''){
              // this.unitSet[++cnt] = 'timeLimit1'
            this.unitSet.push({name: 'TimeLimit1', path: './timeLimit/TimeLimit1'})
            // }

            for(let i = 1; i < element.unitDtlQuesList.length; i++) {
              // this.unitSet[++cnt] = 'timeLimit2'
              this.unitSet.push({name: 'TimeLimit2', path: './timeLimit/TimeLimit2'})
            }

          } else if(element.unitType == '09') { // 워크시트

            if(element.dtlType == '05'){  // 라디오 - 완료
              // this.unitSet[++cnt] = 'workSheets1'
              this.unitSet.push({name: 'WorkSheets1', path: './weekSheets/WeekSheets1'})
            } else if(element.dtlType == '06'){   // 체크박스 - 완료
              // this.unitSet[++cnt] = 'workSheets2'
              this.unitSet.push({name: 'WorkSheets2', path: './weekSheets/WeekSheets2'})
            } else if(element.dtlType == '07'){   // 주관식-단답형 - 완료
              // this.unitSet[++cnt] = 'workSheets3'
              this.unitSet.push({name: 'WorkSheets3', path: './weekSheets/WeekSheets3'})
            } else if(element.dtlType == '08'){   // 주관식-서술형 - 완료
              // this.unitSet[++cnt] = 'workSheets4'
              this.unitSet.push({name: 'WorkSheets4', path: './weekSheets/WeekSheets4'})
            } else if(element.dtlType == '09'){   // 주관식-리스트
              // this.unitSet[++cnt] = 'workSheets7'
              this.unitSet.push({name: 'WorkSheets7', path: './weekSheets/WeekSheets7'})
            } else if(element.dtlType == '10'){   // 문장완성형 - 완료
              // this.unitSet[++cnt] = 'workSheets5'
              this.unitSet.push({name: 'WorkSheets5', path: './weekSheets/WeekSheets5'})
            } else if(element.dtlType == '11'){   // 우선순위형 - 완료
              // this.unitSet[++cnt] = 'workSheets6'
              this.unitSet.push({name: 'WorkSheets6', path: './weekSheets/WeekSheets6'})
            }

          } else if(element.unitType == '10') { // 콘텐츠제공형 -- 도서관 불러오는부분 작업 필요
            // this.unitSet[++cnt] = 'content'
            this.unitSet.push({name: 'Content', path: './content/Content'})
          } else if(element.unitType == '11') { // 노트형
            // this.unitSet[++cnt] = 'note'
            this.unitSet.push({name: 'Note', path: './solutionNote/SolutionNote'})
          }
        });

        // this.unitSet[++cnt] = 'finish'
      }
      if (this.popupYn) { // 가이드 피드백 & 광장에서는 intro 페이지 x
        this.unitSet.splice(0, 1)
      }
      // else {
        this.unitSet.push({name: 'Finish', path: './SolutionFinish'})
      // }
    },
     settleDetailList () {
       this.unitDtlUseList.forEach((unitDtlUse) => {
         let pageSeqTmp = 0
         unitDtlUse.unitDtlQuesList.forEach((unitDtlUseQes) => {
           // 페이지별 DtlUseNo, PageSeq
           if(pageSeqTmp != unitDtlUseQes.unitDtlPageSeq) {
             this.unitDtlUseNo.push(unitDtlUseQes.unitDtlUseNo)
             this.unitDtlPageSeq.push(unitDtlUseQes.unitDtlPageSeq)

             if (unitDtlUse.unitType == '03'  // 온도계 선택개수가 2개 이상인경우 페이지 추가
                 && (unitDtlUseQes.selectCnt > 0)){

               this.unitDtlUseNo.push(unitDtlUseQes.unitDtlUseNo)
               this.unitDtlPageSeq.push(unitDtlUseQes.unitDtlPageSeq)
             }
             else if(unitDtlUse.unitType == '06') {
             // else if(unitDtlUse.unitType == '06'  // 호흡형의 경우 관리자에서 시간설정 안한경우 사용자 페이지 추가
             //     && (unitDtlUseQes.timeSet == null || unitDtlUseQes.timeSet <= 0 || unitDtlUseQes.timeSet == '')){

               this.unitDtlUseNo.push(unitDtlUseQes.unitDtlUseNo)
               this.unitDtlPageSeq.push(unitDtlUseQes.unitDtlPageSeq)
             }
             else if(unitDtlUse.unitType == '07'){// 몰입훈련형 페이지 추가

               this.unitDtlUseNo.push(unitDtlUseQes.unitDtlUseNo)
               this.unitDtlPageSeq.push(unitDtlUseQes.unitDtlPageSeq)
             }
             else if(unitDtlUse.unitType == '05' && unitDtlUse.dtlType == '04'){// 그래프 자유형 페이지 추가

               this.unitDtlUseNo.push(unitDtlUseQes.unitDtlUseNo)
               this.unitDtlPageSeq.push(unitDtlUseQes.unitDtlPageSeq)
             }

             pageSeqTmp = unitDtlUseQes.unitDtlPageSeq
           }

           // 완료 미션이 아닌경우 마지막 작성 페이지로 이동
           if(!this.cmpltYn && this.cmpltYn !== undefined){
             if(unitDtlUseQes.replyYn == "Y"){
               this.current = this.unitDtlPageSeq.length
             }
           }
         })
       })
     }
   }
}
</script>
